import { createContext, useContext } from 'react'

export const TabContext = createContext({
  activeTabId: null,
  setActiveTabId: () => {},
})

export const useTabContext = () => {
  const context = useContext(TabContext)
  return context
}
